import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CloseIcon from "@mui/icons-material/Close";
import Coin from "../../assets/stcoin.png";
import Image from "next/image";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useCurrencyCode } from "../genericComponents/helper-functions/CurrencySymbol";
import { getToken } from "@/app/services/HolderService";
import { ResponseObject } from "@/app/classes/main";
import { ApiService } from "@/app/services/AppService";

interface WalletBalanceProps {
  openWalletDetails: any;
  handleCloseWalletDetails: any;
}

const WalletBalance: React.FC<WalletBalanceProps> = ({
  openWalletDetails,
  handleCloseWalletDetails,
}) => {
  const [click, setClick] = React.useState(false);
  const [screenWidth, setScreenWidth] = React.useState<number>(0);

  React.useEffect(() => {
    // This will run only on the client-side
    if (typeof window !== "undefined") {
      setScreenWidth(window.innerWidth);
    }
  }, []);

  const handleOpenPassbookDetails = () => {
    setClick((prevClick) => !prevClick);
  };
  const currencyCode = useCurrencyCode();
  const token = getToken();
  const apiService = React.useMemo(() => new ApiService(), []);

  const getWalletDetails = React.useCallback(async () => {
    const payload = {
      endDate: "30-12-2024",
      page: 0,
      startDate: "01-6-2023",
    };
    try {
      if (token) {
        const responseObject: ResponseObject | undefined =
          await apiService.post<ResponseObject>(
            apiService.walletBalance,
            payload,
            token!
          );
        //   const serviceDataOneRs = responseObject?.object;
        //   setRecommendedData(serviceDataOneRs);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }, [apiService, token]);

  React.useEffect(() => {
    getWalletDetails();
  }, [getWalletDetails]);

  return (
    <React.Fragment>
      <Dialog
        open={openWalletDetails}
        onClose={handleCloseWalletDetails}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        fullScreen={screenWidth < 600 ? true : false}
        PaperProps={{
          sx: {
            scrollbarWidth: "none", // For Firefox
            msOverflowStyle: "none", // For Internet Explorer and Edge
            "::webkitScrollbar": {
              display: "none",
            },
            background: "#f0f0f0",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            textAlign: "right",
            padding: "0.5rem",
          }}
        >
          <IconButton
            aria-label="delete"
            sx={{ color: "#15741a", padding: "8px" }}
            onClick={handleCloseWalletDetails}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Box>
        {click ? (
          <Box sx={{ padding: "1rem" }}>
            <Box
              sx={{
                width: "auto",
                textAlign: "left",
                padding: "0.5rem",
                position: "absolute",
                top: 0,
              }}
            >
              <IconButton
                aria-label="delete"
                sx={{ color: "#15741a", padding: "4px" }}
                onClick={handleOpenPassbookDetails}
              >
                <KeyboardBackspaceIcon
                  sx={{
                    background: "#fff",
                    borderRadius: "1rem",
                    padding: "4px",
                    fontSize: "28px",
                    position: "absolute",
                    top: 0,
                    cursor: "pointer",
                    color: "#000",
                    boxShadow: "2px 1px 4px 1px rgba(0, 0, 0, 0.1)",
                    zIndex: 100,
                  }}
                />
              </IconButton>
            </Box>
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                position: "absolute",
                top: 25,
                width: "-webkit-fill-available",
              }}
            >
              PassBook
            </Typography>
            <Box
              sx={{ background: "#fff", borderRadius: "1rem", padding: "1rem" }}
            >
              <Typography
                variant="body1"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "0.5rem 0px",
                }}
              >
                <span style={{ fontWeight: "bold" }}> credit</span>
                <span>02,may 2024 11.42 AM</span>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>welcome</span>
                <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>Opening Balance</span>
                <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>Amount</span>
                <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>Closing Balance</span>
                <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>Coins Opening Balance</span>
                <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>Salontym Coins</span>
                <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>Coins Closing Balance</span>
                <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
              </Typography>
            </Box>
          </Box>
        ) : (
          <>
            <Box
              sx={{
                width: "100%",
                padding: "1rem",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  position: "absolute",
                  top: 25,
                  width: "-webkit-fill-available",
                }}
              >
                My Wallet
              </Typography>

              <Box>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  Wallet Balance
                </Typography>
                <Typography variant="h5" sx={{ margin: "0.5rem 0px" }}>
                  {currencyCode}50
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ display: "flex", margin: "0.5rem 0px" }}
                >
                  <Image
                    height={500}
                    width={500}
                    src={Coin}
                    alt="coins"
                    style={{
                      height: "30px",
                      width: "30px",
                      objectFit: "cover",
                      borderRadius: "1rem 0px 0px 1rem",
                    }}
                  />
                  100 Coins
                </Typography>
                <Typography variant="body1" sx={{ margin: "0.5rem 0px" }}>
                  Hurry Up!! We are calculating your referral amount here...
                </Typography>
                <Divider sx={{ margin: "1rem 0px" }} />
                <Typography
                  variant="body1"
                  sx={{ margin: "0.5rem 0px", fontWeight: "bold" }}
                >
                  Latest Transactions
                </Typography>
                <Box
                  sx={{
                    background: "#fff",
                    borderRadius: "1rem",
                    padding: "1rem",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      margin: "0.5rem 0px",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}> credit</span>
                    <span>02,may 2024 11.42 AM</span>
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>welcome</span>
                    <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>Opening Balance</span>
                    <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>Amount</span>
                    <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>Closing Balance</span>
                    <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>Coins Opening Balance</span>
                    <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>Salontym Coins</span>
                    <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>Coins Closing Balance</span>
                    <span style={{ fontWeight: "bold" }}>{currencyCode}0</span>
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  color="success"
                  sx={{
                    width: "100%",
                    borderRadius: "10rem",
                    background: "#15741a",
                    marginTop: "1rem",
                    textTransform: "capitalize",
                    padding: "8px 16px",
                  }}
                  endIcon={<KeyboardArrowRightIcon />}
                  onClick={handleOpenPassbookDetails}
                >
                  View Complete Passbook
                </Button>
              </Box>
            </Box>
          </>
        )}
      </Dialog>
    </React.Fragment>
  );
};

export default WalletBalance;
